module.exports = "/_next/static/images/CustomerDataFoundation@2x-ccd3ad014b00b3d7e1f4d7000dfa7f1a.webp";